(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tw-subscription"] && !Shopify.designMode) return;
  try {
    class TwSubscription extends HTMLElement {
  connectedCallback() {
    this.planInput = this.planInput || this.querySelector('[data-tw-plan-input]');
    this.cards = Array.from(this.querySelectorAll('[data-tw-card]'));

    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-tw-plan-radio]')) {
        this.select(event.target);
      }
    });

    this.addEventListener('click', (event) => {
      if (event.target.closest('label, a, button, input')) return;
      const card = event.target.closest('[data-tw-card]');
      const radio = card && card.querySelector('[data-tw-plan-radio]');
      if (radio && !radio.checked) {
        radio.checked = true;
        this.select(radio);
      }
    });

    // This block renders above the product form, so on first parse the form does not
    // exist yet and neither the plan input nor the variant can be set. Without this the
    // default selection reaches the cart unset — it only worked once you clicked a plan.
    const applyInitialSelection = () => {
      this.adoptInput();
      const checked = this.querySelector('[data-tw-plan-radio]:checked');
      if (checked) this.select(checked);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyInitialSelection, { once: true });
    } else {
      applyInitialSelection();
    }

    // The theme initialises its own product form after us and writes the page's variant
    // back into [data-product-select], wiping our value. Re-assert in the capture phase
    // so the correct variant is in place before the theme reads FormData on submit.
    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest('[data-add-to-cart]')) return;
        const checked = this.querySelector('[data-tw-plan-radio]:checked');
        if (!checked) return;
        this.adoptInput();
        this.syncVariant(checked);
      },
      true
    );
  }

  get productForm() {
    const byId = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
    if (byId) return byId;

    const scope = this.closest('[data-section-id]') || document;
    return (
      scope.querySelector('form[data-product-form]') ||
      scope.querySelector('form[action*="/cart/add"]')
    );
  }

  adoptInput() {
    const form = this.productForm;
    if (!form || !this.planInput) return;

    if (this.planInput.parentElement !== form) {
      form.appendChild(this.planInput);
    }

    this.planInput.removeAttribute('form');
  }

  syncVariant(radio) {
    const form = this.productForm;
    if (!form) return;

    const field = form.querySelector('[name="id"]');
    const variantId = radio.dataset.variantId || this.dataset.defaultVariant;
    if (field && variantId) field.value = variantId;
  }

  select(radio) {
    const planId = radio.dataset.planId || '';

    this.adoptInput();

    // A row may sell a different product, so the variant has to follow the choice —
    // and fall back to the page's own variant when it doesn't.
    this.syncVariant(radio);

    if (this.planInput) {
      this.planInput.value = planId;
      this.planInput.disabled = planId === '';
    }

    this.cards.forEach((card) => {
      card.classList.toggle('is-selected', card.contains(radio));
    });

    this.dispatchEvent(
      new CustomEvent('tw-subscription:change', {
        bubbles: true,
        detail: { sellingPlanId: planId }
      })
    );
  }
}

if (!customElements.get('tw-subscription')) {
  customElements.define('tw-subscription', TwSubscription);
}
  } catch(e) { console.error(e); }
})();

})();
